import React, { useState } from 'react';
import SolutionCalc from './components/solutionCalc/SolutionCalc';

import {
  Paper,
  MainTitle,
  MainCalWrapper,
  MainCalc,
  MainInput,
  MainActions,
  Hr,
} from './styled/stylezz';

const App = () => {
  const [inputX, setInputX] = useState('');
  const [inputY, setInputY] = useState('');

  const [solutionShow, setSolutionShow] = useState(false);

  const handleSolution = () => {
    setSolutionShow(true);
  };

  const handleCleanInput = () => {
    setInputX('');
    setInputY('');

    setSolutionShow(false);
  };
  return (
    <React.Fragment>
      <Paper>
        <MainTitle>Калькулятор</MainTitle>
        <MainCalWrapper>
          <span style={{ fontSize: '20px' }}>Введите данные:</span>
          <Hr />
          <MainCalc>
            <span>Начальная цена:</span>
            <MainInput
              type="number"
              onChange={(e) => setInputX(e.target.value)}
              value={inputX}
            />{' '}
            Процент скидки:{' '}
            <MainInput
              type="number"
              value={inputY}
              onChange={(e) => setInputY(e.target.value)}
            />
          </MainCalc>
          <Hr />

          <MainActions>
            <button onClick={handleSolution}>Решение</button>
            <button onClick={handleCleanInput}>Сбросить</button>
          </MainActions>
        </MainCalWrapper>

        {solutionShow && (
          <SolutionCalc inputX={Math.abs(+inputX)} inputY={Math.abs(+inputY)} />
        )}
      </Paper>
    </React.Fragment>
  );
};

export default App;
